import { useQuery } from '@tanstack/react-query';
import { contasReceberService } from '../services/contasReceberService';

export const useDetalheContaReceber = (id: number | null) =>
  useQuery({
    queryKey: ['conta-receber-detalhe', id],
    queryFn: () => contasReceberService.getDetalhe(id!),
    enabled: id !== null && id > 0,
  });
